(function () {
    const infoSection = document.querySelector('.about__add-text');
    const infoBtns = document.querySelectorAll('.about__switch-btn');

    if (infoSection && infoBtns) {
        infoBtns.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();

                infoBtns.forEach(btn => btn.classList.remove('about__switch-btn_hide'))
                e.target.classList.add('about__switch-btn_hide');

                infoSection.classList.toggle('about__add-text_show');
            })
        })
    }
}());
